import { actionTypes } from 'actions/actionTypes'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

// TODO TG-7077 update argument type

/**
 * Action creator to update "Pay within 20 minutes before session ends" banner status on top of Checkout page.
 */
export const checkoutUrgencySetCurrentStatus: CheckoutActionCreator = (currentStatus: string) => ({
  type: actionTypes.CHECKOUT_URGENCY_SET_CURRENT_STATUS,
  currentStatus,
})
